import { createBrowserHistory } from 'history';
import { get, has, merge, set } from 'lodash';
var qs = require('qs');
var history = createBrowserHistory();
var UrlPropManager = (function () {
    function UrlPropManager(namespace) {
        this.namespace = namespace;
    }
    UrlPropManager.prototype.all = function () {
        var props = this.getUrlProps();
        if (this.namespace) {
            return get(props, this.namespace) || {};
        }
        return props;
    };
    UrlPropManager.prototype.get = function (key) {
        return get(this.all(), key, null);
    };
    UrlPropManager.prototype.has = function (key) {
        return has(this.all(), key);
    };
    UrlPropManager.prototype.push = function (props) {
        history.push({
            pathname: window.location.pathname,
            search: this.encode(this.merge(props))
        });
    };
    UrlPropManager.prototype.clear = function () {
        var props = this.getUrlProps();
        if (this.namespace) {
            delete props[this.namespace];
        }
        history.push({
            pathname: window.location.pathname,
            search: this.encode(props)
        });
    };
    UrlPropManager.prototype.mergeLink = function (props) {
        return "?".concat(this.encode(this.merge(props)));
    };
    UrlPropManager.prototype.replaceLink = function (props) {
        return "?".concat(this.encode(this.namespaceProps(props)));
    };
    UrlPropManager.prototype.encode = function (props) {
        return qs.stringify(props, { encodeValuesOnly: true, skipNulls: true });
    };
    UrlPropManager.prototype.merge = function (props) {
        props = this.namespaceProps(props);
        return merge(this.getUrlProps(), props);
    };
    UrlPropManager.prototype.namespaceProps = function (props) {
        if (this.namespace) {
            props = set({}, this.namespace, props);
        }
        return props;
    };
    UrlPropManager.prototype.getUrlProps = function () {
        return qs.parse(location.search.substr(1));
    };
    UrlPropManager.prototype.listen = function (callback) {
        var _this = this;
        return history.listen(function (location, action) {
            callback(_this.all());
        });
    };
    return UrlPropManager;
}());
var useUrlProps = function (namespace) {
    return new UrlPropManager(namespace);
};
export { useUrlProps };
export default UrlPropManager;
